import { render, staticRenderFns } from "./finishBoxMobile.vue?vue&type=template&id=08532ad7&scoped=true&"
import script from "./finishBoxMobile.vue?vue&type=script&lang=js&"
export * from "./finishBoxMobile.vue?vue&type=script&lang=js&"
import style0 from "./finishBoxMobile.vue?vue&type=style&index=0&id=08532ad7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08532ad7",
  null
  
)

export default component.exports